/* eslint-disable max-len */
import React from 'react';
function LocationFilterOutlined() {
    return (React.createElement("g", null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 9C2 5.13 5.13 2 9 2C12.87 2 16 5.13 16 9C16 14.25 9 22 9 22C9 22 2 14.25 2 9ZM9 4C6.24 4 4 6.24 4 9C4 11.85 6.92 16.21 9 18.88C11.12 16.19 14 11.88 14 9C14 6.24 11.76 4 9 4ZM9 6.5C7.61929 6.5 6.5 7.61929 6.5 9C6.5 10.3807 7.61929 11.5 9 11.5C9.89316 11.5 10.7185 11.0235 11.1651 10.25C11.6116 9.4765 11.6116 8.5235 11.1651 7.75C10.7185 6.9765 9.89316 6.5 9 6.5ZM18 11H22V9L18 9L18 11ZM22 19H15V17H22V19ZM17 15H22V13L17 13V15Z" })));
}
export default LocationFilterOutlined;
